import { withInstall } from '@pit-element-plus/utils'
import BaseTabs from './src/tabs'

export const ElBaseTabs = withInstall(BaseTabs)
export default ElBaseTabs

export * from './src/tabs'
